const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  showImage: true
};

export { defaultOptions, pluginVersion };
